// src/utils/dashboardApiService.js
import { apiGet, withAuth } from "./apiClient";

// responses can be { data: [...] } OR [...]
const unwrapArray = (payload) => {
	if (Array.isArray(payload)) return payload;
	if (payload && Array.isArray(payload.data)) return payload.data;
	return [];
};

const assertInputs = ({ partnerName, startDate, endDate, token }) => {
	if (!token) throw new Error("Missing auth token");
	if (!partnerName) throw new Error("Missing partnerName");
	if (!startDate || !endDate) throw new Error("Missing date range");
};

export async function fetchRevenueDomains({
	partnerName,
	startDate,
	endDate,
	token,
	signal
}) {
	assertInputs({ partnerName, startDate, endDate, token });

	const payload = await apiGet(
		`revenue/${encodeURIComponent(partnerName)}/domains`,
		{
			headers: withAuth(token),
			signal,
			params: { start: startDate, end: endDate }
		}
	);

	return unwrapArray(payload);
}

export async function fetchRevenueCountries({
	partnerName,
	startDate,
	endDate,
	domain, // optional
	token,
	signal
}) {
	assertInputs({ partnerName, startDate, endDate, token });

	const params = { start: startDate, end: endDate };

	// ✅ only send domain if NOT ALL
	if (domain && String(domain) !== "all") {
		params.domain = domain;
	}

	const payload = await apiGet(
		`revenue/${encodeURIComponent(partnerName)}/countries`,
		{
			headers: withAuth(token),
			signal,
			params
		}
	);

	return unwrapArray(payload);
}

export async function fetchAnalyticsDomains({
	partnerName,
	startDate,
	endDate,
	token,
	signal
}) {
	assertInputs({ partnerName, startDate, endDate, token });

	const payload = await apiGet(
		`analytics/${encodeURIComponent(partnerName)}/domains`,
		{
			headers: withAuth(token),
			signal,
			params: { start: startDate, end: endDate }
		}
	);

	return unwrapArray(payload);
}

export async function fetchAnalyticsCountries({
	partnerName,
	startDate,
	endDate,
	domain, // optional
	token,
	signal
}) {
	assertInputs({ partnerName, startDate, endDate, token });

	const params = { start: startDate, end: endDate };

	// ✅ only send domain if NOT ALL
	if (domain && String(domain) !== "all") {
		params.domain = domain;
	}

	const payload = await apiGet(
		`analytics/${encodeURIComponent(partnerName)}/countries`,
		{
			headers: withAuth(token),
			signal,
			params
		}
	);

	return unwrapArray(payload);
}
